import { css } from "styled-components";
import { CourseNameCss, NoteCss, UnitPriceAmount, UnitPriceRoot, UnitPriceUnit } from "components/front/layout/content/CourseListCss";

const BG_COLOR_GRAY = "rgba(104, 104, 104, 0.5)";
const BG_COLOR_GRAY_DARK = "rgba(36, 36, 36, 0.5)";
const ProjectContentCss = css`
  .content-box1 {
    .main-bg {
      @media screen and (max-width: 960px) {
        padding: 20px 10px 10px;
        font-size: 13px;
        line-height: 1.428em;
      }
      @media screen and (min-width: 961px) and (max-width: 1280px) {
        padding: 20px;
        font-size: 13px;
        line-height: 1.65em;
      }
      @media screen and (min-width: 1281px) {
        padding: 20px;
        font-size: 15px;
        line-height: 1.65em;
      }
    }
    .top-bg {
      width: 100%;
      height: 16px;
      position: relative;

      &:before {
        content: "";
        width: calc(100% - 16px);
        height: 16px;
        position: absolute;
        top: 0;
        left: 0;
      }

      &:after {
        content: "";
        border-style: solid;
        border-width: 0 16px 16px 0;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .bottom-bg {
      width: 100%;
      height: 16px;
      position: relative;

      &:before {
        content: "";
        width: calc(100% - 20px);
        height: 16px;
        position: absolute;
        top: 0;
        right: 0;
      }

      &:after {
        content: "";
        border-style: solid;
        border-width: 16px 0 0 16px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    &.gray {
      .main-bg {
        background-color: ${BG_COLOR_GRAY};
        border-right: 4px solid ${BG_COLOR_GRAY_DARK};
      }
      .top-bg {
        &:before {
          background-color: ${BG_COLOR_GRAY};
        }
        &:after {
          border-color: transparent transparent ${BG_COLOR_GRAY} transparent;
        } 
      }
      .bottom-bg {
        &:before {
          background-color: ${BG_COLOR_GRAY};
          border-right: 4px solid ${BG_COLOR_GRAY_DARK};
          border-bottom: 4px solid ${BG_COLOR_GRAY_DARK};
        }
        &:after {
          border-color: ${BG_COLOR_GRAY} transparent transparent transparent;
        }
      }
    }
  }
  .content-subtitle {
    color: white;
    margin-bottom: 10px;
    display: inline-block;
    line-height: 1;
    border-left: 5px solid white;
    padding-left: 8px;
    @media screen and (max-width: 960px) {
      font-size: 16px;
    }
    @media screen and (min-width: 961px) and (max-width: 1280px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1281px) {
      font-size: 20px;
    }
  }
  .content-caption {
    background-color: rgba(104, 104, 104, 0.5);
    width: 100%;
    display: inline-block;
    color: white;
    margin: 5px 0 10px;
    line-height: 1;
    @media screen and (max-width: 960px) {
      text-align: center;
      padding: 5px;
      font-size: 16px;
    }
    @media screen and (min-width: 961px) {
      text-align: left;
      padding: 10px;
      font-size: 20px;
    }
    @media screen and (min-width: 1281px) {
      font-size: 22px;
    }
  }
  .content-price {
    ${UnitPriceRoot};
    .amount {
      ${UnitPriceAmount};
    }
    .unit {
      ${UnitPriceUnit};
    }
  }
  .content-name {
    ${CourseNameCss};
  }
  .content-note {
    ${NoteCss};
  }
  .content-return-button {
    display: block;
    width: 100%;
    height: 44px;
    //height: 100%;
    position: relative;
    cursor: "pointer";
    pointer-events:"auto";
    top:25px;
  }

  .text-area {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    text-align: center;
    font-style: italic;
    top: 0;
    left: 6px;
  }

  .upper-bg {
    width: calc(100% - 6px);
    height: 50%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 6px;
  }

  .upper-item1{   
    position: absolute;
    width: calc(100% - 2px); 
    height: calc(100% - 2px);
    background-color: #00ff00;
    top: 2px;
    right: 2px; 
  }
  .upper-item2{
    position: absolute;
    width: calc(100% - 4px);
    height: 100%;
    background-color: #ff0000;
    top: 0;
    left: 0;
  }
  .upper-item3{
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 2px);
    background-color: #ffff00;
    top: 2px;
    left: 2px;
  }
  .upper-item4{
    position: absolute;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    background-color: #0000ff;
    top: 4px;
    right: 0;
  }
  .upper-item5{
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 4px);
    top: 4px;
    right: 2px;
    background-color: #00ffff;
  }
  .upper-item6{
    position: absolute;
    width: calc(100% - 8px);
    height: calc(100% - 4px);
    background-color: #fff;
    top: 4px;
    left: 4px;
  }
  .upper-item7{
    position: absolute;
    opacity: 0;
    width: 36px;
    height: 2px;
    background-color: #fff;
    top: 14px;
    left: 15px;
  }
  .upper-item8{
    position: absolute;
    opacity: 0;
    width: 36px;
    height: 3px;
    background-color: #ff0000;
    top: 18px;
    left: -4px;
  }
  
  .lower-bg{
    width: calc(100% - 6px);
    height: 50%;
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
  }

  .lower-item1{
    position: absolute;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    background-color: #00ff00;
    bottom: 2px;
    left: 2px;
  }
  .lower-item2{
    position: absolute;
    width: calc(100% - 4px);
    height: 100%;
    background-color: #0000ff;
    bottom: 0;
    right: 0;
  }
  .lower-item3{
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 2px);
    bottom: 2px;
    right: 2px;
    background-color: #00ffff;
  }
  .lower-item4{
    position: absolute;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    bottom: 4px;
    left: 0;
    background-color: #ff0000;
  }
  .lower-item5{
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 4px);
    bottom: 4px;
    left: 2px;
    background-color: #ffff00;
  }
  .lower-item6{
    position: absolute;
    width: calc(100% - 8px);
    height: calc(100% - 4px);
    background-color: #fff;
    bottom: 4px;
    left: 4px;
  }
  .lower-item7{
    position: absolute;
    opacity: 0;
    width: 36px;
    height: 2px;
    background-color: #00ffff;
    top: 16px;
    right: 10px;
  }
  
  .lower-item8{
    position: absolute;
    opacity: 0;
    width: 36px;
    height: 3px;
    background-color: #fff;
    top: 21px;
    right: -3px;

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
    }

    &:before {
      width: 2px;
      height: 3px;
      right: -4px;
      background-color: #0000ff;
    }

    &:after {
      width: 2px;
      height: 3px;
      right: -2px;
      background-color: #00ffff;
    }
  }

  @media screen and (min-width: 961px) {
    .content-return-button:hover .text-area { 
      animation: textFlash 2s infinite;;
    }

    .content-return-button:hover .upper-item1 { 
      animation: gritchUpper01 1.2s 0s infinite step-start;
    }

    .content-return-button:hover .upper-item2 {
      animation: gritchUpper02 1.2s 0s infinite step-start;
    }

    .content-return-button:hover .upper-item3 {
      animation: gritchUpper03 1.2s 0s infinite step-start;
    }

    .content-return-button:hover .upper-item4 {
      animation: gritchUpper04 1.2s 0s infinite step-start;
    }

    .content-return-button:hover .upper-item5 {
      animation: gritchUpper05 1.2s 0s infinite step-start;
    }

    .content-return-button:hover .upper-item6 {
      animation: gritchUpper06 1.2s 0s infinite step-start;
    }

    .content-return-button:hover .upper-item7 {
      animation: gritchUpper07 1.2s 0s infinite step-start;
    }

    .content-return-button:hover .upper-item8 {
      animation: gritchUpper08 1.2s 0s infinite step-start;
    }

    .content-return-button:hover .lower-item1 {
      animation: gritchLower01 1.2s 0s infinite step-start;
    }
    
    .content-return-button:hover .lower-item2 {
      animation: gritchLower02 1.2s 0s infinite step-start;
    }
    
    .content-return-button:hover .lower-item3 {
      animation: gritchLower03 1.2s 0s infinite step-start;
    }
    
    .content-return-button:hover .lower-item4 {
      animation: gritchLower04 1.2s 0s infinite step-start;
    }
    
    .content-return-button:hover .lower-item5 {
      animation: gritchLower05 1.2s 0s infinite step-start;
    }
    
    .content-return-button:hover .lower-item6 {
      animation: gritchLower06 1.2s 0s infinite step-start; 
    }
    
    .content-return-button:hover .lower-item7 {
      animation: gritchLower07 1.2s 0s infinite step-start;
    }
    
    .content-return-button:hover .lower-item8 {
      animation: gritchLower08 1.2s 0s infinite step-start;
    }

    @keyframes textFlash {
      0% {
        opacity: 0;
        -webkit-transform: translateX(-8px);
                transform: translateX(-8px); }
      1% {
        opacity: 1;
        -webkit-transform: translateX(0px);
                transform: translateX(0px); }
      2% {
        opacity: 0;
        -webkit-transform: translateX(8px);
                transform: translateX(8px); }
      3% {
        opacity: 1;
        -webkit-transform: translateX(0px);
                transform: translateX(0px); }
      4% {
        opacity: 0;
        -webkit-transform: translateX(-10px);
                transform: translateX(-10px); }
      5% {
        opacity: 1;
        -webkit-transform: translateX(0px);
                transform: translateX(0px); }
      100% {
        opacity: 1;
        -webkit-transform: translateX(0px);
                transform: translateX(0px); } }

    @keyframes gritchUpper01 {
      0% {
        width: calc(100% - 2px);
        right: 2px; }
      5% {
        width: calc(100% - 2px);
        right: -10px; }
      10% {
        width: calc(100% - 2px);
        right: 20px; }
      15% {
        width: calc(100% - 12px);
        right: -10px; }
      20% {
        width: calc(100% - 2px);
        right: 2px; }
      100% {
        width: calc(100% - 2px);
        right: 2px; } }
    @keyframes gritchUpper02 {
      0% {
        width: calc(100% - 4px);
        left: 0; }
      5% {
        width: calc(100% - 4px);
        left: 12px; }
      10% {
        width: calc(100% - 4px);
        left: -18px; }
      15% {
        width: calc(100% - 14px);
        left: 18px; }
      20% {
        width: calc(100% - 4px);
        left: 0; }
      100% {
        width: calc(100% - 4px);
        left: 0; } }
    @keyframes gritchUpper03 {
      0% {
        width: calc(100% - 6px);
        left: 2px; }
      5% {
        width: calc(100% - 8px);
        left: 14px; }
      10% {
        width: calc(100% - 10px);
        left: -18px; }
      15% {
        width: calc(100% - 18px);
        left: 20px; }
      20% {
        width: calc(100% - 6px);
        left: 2px; }
      100% {
        width: calc(100% - 6px);
        left: 2px; } }
    @keyframes gritchUpper04 {
      0% {
        width: calc(100% - 4px);
        right: 0; }
      5% {
        width: calc(100% - 4px);
        right: -12px; }
      10% {
        width: calc(100% - 4px);
        right: 18px; }
      15% {
        width: calc(100% - 14px);
        right: -12px; }
      20% {
        width: calc(100% - 4px);
        right: 0; }
      100% {
        width: calc(100% - 4px);
        right: 0; } }
    @keyframes gritchUpper05 {
      0% {
        width: calc(100% - 6px);
        right: 2px; }
      5% {
        width: calc(100% - 6px);
        right: -10px; }
      10% {
        width: calc(100% - 6px);
        right: 20px; }
      15% {
        width: calc(100% - 16px);
        right: -10px; }
      20% {
        width: calc(100% - 6px);
        right: 2px; }
      100% {
        width: calc(100% - 6px);
        right: 2px; } }
    @keyframes gritchUpper06 {
      0% {
        width: calc(100% - 8px);
        left: 4px; }
      5% {
        width: calc(100% - 13px);
        left: 21px; }
      10% {
        width: calc(100% - 13px);
        left: -13px; }
      15% {
        width: calc(100% - 18px);
        left: 22px; }
      20% {
        width: calc(100% - 8px);
        left: 4px; }
      100% {
        width: calc(100% - 8px);
        left: 4px; } }
    @keyframes gritchUpper07 {
      0% {
        top: 14px;
        left: 11px;
        opacity: 0; }
      5% {
        top: 14px;
        left: 11px;
        opacity: 1; }
      10% {
        top: 14px;
        left: 11px;
        opacity: 0; }
      15% {
        top: 7px;
        left: 8px;
        opacity: 1; }
      20% {
        top: 14px;
        left: 11px;
        opacity: 0; }
      100% {
        top: 14px;
        left: 15px;
        opacity: 0; } }
    @keyframes gritchUpper08 {
      0% {
        top: 18px;
        left: -4px;
        opacity: 0; }
      5% {
        top: 18px;
        left: -4px;
        opacity: 1; }
      10% {
        top: 18px;
        left: -4px;
        opacity: 0; }
      15% {
        top: 36px;
        left: -30px;
        opacity: 1; }
      20% {
        top: 18px;
        left: -4px;
        opacity: 0; }
      100% {
        top: 18px;
        left: -4px;
        opacity: 0; } }

    @keyframes gritchLower01 {
      0% {
        width: calc(100% - 2px);
        left: 2px; }
      5% {
        width: calc(100% - 2px);
        left: -8px; }
      10% {
        width: calc(100%);
        left: 14px; }
      15% {
        width: calc(100% - 10px);
        left: -10px; }
      20% {
        width: calc(100% - 2px);
        left: 2px; }
      100% {
        width: calc(100% - 2px);
        left: 2px; } }
    @keyframes gritchLower02 {
      0% {
        width: calc(100% - 4px);
        right: 0; }
      5% {
        width: calc(100%);
        right: 9px; }
      10% {
        width: calc(100% + 10px);
        right: -18px; }
      15% {
        width: calc(100% - 10px);
        right: 18px; }
      20% {
        width: calc(100% - 4px);
        right: 0; }
      100% {
        width: calc(100% - 4px);
        right: 0; } }
    @keyframes gritchLower03 {
      0% {
        width: calc(100% - 6px);
        right: 2px; }
      5% {
        width: calc(100% - 9px);
        right: 14px; }
      10% {
        width: calc(100% - 1px);
        right: -15px; }
      15% {
        width: calc(100% - 16px);
        right: 20px; }
      20% {
        width: calc(100% - 6px);
        right: 2px; }
      100% {
        width: calc(100% - 6px);
        right: 2px; } }
    @keyframes gritchLower04 {
      0% {
        width: calc(100% - 4px);
        left: 0; }
      5% {
        width: calc(100% - 4px);
        left: -12px; }
      10% {
        width: calc(100% - 1px);
        left: 12px; }
      15% {
        width: calc(100% - 14px);
        left: -12px; }
      20% {
        width: calc(100% - 4px);
        left: 0; }
      100% {
        width: calc(100% - 4px);
        left: 0; } }
    @keyframes gritchLower05 {
      0% {
        width: calc(100% - 6px);
        left: 2px; }
      5% {
        width: calc(100% - 4px);
        left: -12px; }
      10% {
        width: calc(100% - 4px);
        left: 14px; }
      15% {
        width: calc(100% - 16px);
        left: -10px; }
      20% {
        width: calc(100% - 6px);
        left: 2px; }
      100% {
        width: calc(100% - 6px);
        left: 2px; } }
    @keyframes gritchLower06 {
      0% {
        width: calc(100% - 8px);
        left: 4px; }
      5% {
        width: calc(100% - 11px);
        left: -9px; }
      10% {
        width: calc(100% - 8px);
        left: 16px; }
      15% {
        width: calc(100% - 18px);
        left: -12px; }
      20% {
        width: calc(100% - 8px);
        left: 4px; }
      100% {
        width: calc(100% - 8px);
        left: 4px; } }
    @keyframes gritchLower07 {
      0% {
        opacity: 0; }
      5% {
        opacity: 1; }
      10% {
        opacity: 0; }
      15% {
        opacity: 0; }
      20% {
        opacity: 0; }
      100% {
        opacity: 0; } }
    @keyframes gritchLower08 {
      0% {
        top: 21px;
        right: -3px;
        opacity: 0; }
      5% {
        top: 21px;
        right: -3px;
        opacity: 1; }
      10% {
        top: 21px;
        right: -3px;
        opacity: 0; }
      15% {
        top: 19px;
        right: 2px;
        opacity: 0; }
      20% {
        top: 21px;
        right: -3px;
        opacity: 0; }
      100% {
        top: 21px;
        right: -3px;
        opacity: 0; } }
  }
`;
export default ProjectContentCss;
